import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import { Table } from '../../../../components/Table'
import Button from '../../../../components/components-ui/Button/Button'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/Api'
import Loading from '../../../../components/components-ui/Loading/Loading'

export default function PreferenciaContato() {
  const [listPreferenciaContato, setListaPreferenciaContato] = useState([])
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    async function getPreferenciaContato() {
      setShowLoading(true)
      const response = await api.get('/preferenciacontato/index')
      setListaPreferenciaContato(response.data)
      setShowLoading(false)
    }
    getPreferenciaContato()
  }, [])

  // Colunas da tabela
  const columns = [
    {
      column: 'Preferencia Contato',
    },
  ]

  return (
    <Container>
      <h3>Listagem de Preferencia de Contato</h3>
      <Link to="/usina/preferencia-contato/novo/" style={{ display: "contents" }}>
        <Button title="Novo" type="button" />
      </Link>

      <div className={styles.content}>
        <Table edit columns={columns}>
          {listPreferenciaContato.map(
            ({ IdPreferenciaContato, PreferenciaContato }) => (
              <tr key={IdPreferenciaContato}>
                <td>
                  <Link
                    to={`/usina/preferencia-contato/edit/${IdPreferenciaContato}`}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </Link>
                </td>
                <td>{PreferenciaContato}</td>
              </tr>
            )
          )}
        </Table>
        <div className={styles.loading}>
          <Loading display={showLoading ? 'block' : 'none'} />
        </div>
      </div>
    </Container>
  )
}
